import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../store";
import PropTypes from "prop-types";
import StepProgress from "../step-progress/StepProgress";

class HeaderReact extends PureComponent {
  static defaultProps = {
    stepProgNames: [
      { text: "Application Info" },
      { text: "Plan Selection" },
      { text: "Plan Confirmation" },
    ],
    stepProgStates: [2, 0, 0],
  };

  returnHeaderLogo(siteInfo) {
    const siteLogoClass =
        siteInfo.realm === "LCYTS" ? "pf-icon-logo-yts" : "pf-icon-logo-lcps",
      pfLogoClasses = `pf-icon-logo ${siteLogoClass}`;

    return (
      <span className="visible-sm">
        <a
          id="pf-header-logo-anchor"
          className={pfLogoClasses}
          href={siteInfo.homePageURL}
          aria-label="LendingClub Patient Solutions Logo"
        ></a>
      </span>
    );
  }

  render() {
    const { siteInfo, stepProgStates, stepProgNames } = this.props;

    return (
      <header className="pf-header">
        <div className="pf-header-brand-area">
          <div className="pf-header-logo">
            {this.returnHeaderLogo(siteInfo)}
          </div>
        </div>
        <StepProgress stepNames={stepProgNames} stepStates={stepProgStates} />
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    siteInfo: state.siteInfo,
  };
};

HeaderReact.propTypes = {
  siteInfo: PropTypes.object.isRequired,
  stepProgNames: PropTypes.array.isRequired,
  stepProgStates: PropTypes.array.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actions }, dispatch);
const Header = connect(mapStateToProps, mapDispatchToProps)(HeaderReact);
export default Header;

